export default {
  employees: {
    title: 'Medarbetare ({{count}} st)',
    description: 'Administrera vilka medarbetare som har tillgång till hälsoportalen.',
    searchPlaceholder: 'Sök',
    addEmployeeButton: 'Lägg till medarbetare',
    employeeAdded: '{{firstName}} {{lastName}} tillagd',
    employeesCreated: '{{count}} medarbetare tillagda.',
    employeesAlreadyExisting: '{{count}} medarbetare fanns redan i systemet.',
    employeesAlreadyExistingNoCount: 'Användaren finns redan i systemet.',
    userDeleted: 'Användaren raderad',
    deleteUserError: 'Det gick inte att ta bort användaren, vänligen försök igen.',
    adminPermissionGranted: 'Användaren har fått adminbehörighet.',
    adminPermissionRevoked: 'Användarens adminbehörighet är borttagen.',
    managerResponsibilityRemoved: 'Medarbetaransvar borttaget.',
    managerResponsibilityAdded: 'Medarbetaransvar tillagt.',
    updateUserError: 'Det gick inte att uppdatera användaren.',
    deleteDialogTitle: 'Radera användare',
    deleteDialogUser: 'Användare {{firstName}} {{lastName}} kommer att raderas permanent.',
    deleteDialogConfirmation: 'Är du säker på att du vill fortsätta?',
    deleteDialogConfirm: 'Fortsätt',
  },
  home: {
    title: 'Välkommen till EsterCares hälsoportal!',
    gettingStartedTitle: 'Tips för att komma igång',
    manageEmployeesTitle: 'Hantera medarbetare',
    manageEmployeesDescription: 'Lägg till, ta bort och hantera medarbetare i din organisation.',
    womensHealthPolicyTitle: 'Policy för kvinnohälsa',
    womensHealthPolicyDescription: 'Använd vår mall och ta fram en policy för kvinnohälsa på er arbetsplats.',
    servicesTitle: 'Dina tjänster',
    servicesSeeAll: 'Se alla tjänster',
    participationTitle: 'Deltagande',
    participationSeeAll: 'Se all statistik',
    womensHealthTrainingTitle: 'Deltagande i utbildning om kvinnohälsa',
  },
  invoices: {
    title: 'Fakturering',
    comingSoonTitle: 'Stöd för att kunna se dina fakturor kommer snart!',
    comingSoonMessage: 'Under tiden kan du maila till',
    comingSoonEmail: 'hello@estercare.com',
    comingSoonContinue: 'så hjälper vi dig där!',
  },
  statistics: {
    title: 'Statistik',
    description: 'Följ deltagande och välmående hos era anställda över tid.',
    summaryTitle: 'Kvinnohälsan hos er – i siffror',
    summaryDescription: 'En sammanfattning av hur insatsen påverkar era medarbetares hälsa.',
    summaryHighlightIntro: 'Hälsoprogrammet synliggör hälsobehov och hjälper medarbetare att agera på dem.',
    summaryHighlight:
      'Hälsoprogrammet synliggör hälsobehov och hjälper medarbetare att agera på dem. Inom tre månader rapporterar <bold>{{decreasedSymptomsPct}}%</bold> minskade symtom, <bold>{{lifestylePct}}%</bold> har gjort en livsstilsförändring och <bold>{{workAbilityPct}}%</bold> upplever förbättrad arbetsförmåga.',
    summaryImprovedWorkAbility: 'Upplever förbättrad arbetsförmåga',
    summaryLifestyleChange: 'Har gjort en livsstilsförändring',
    summaryDecreasedSymptoms: 'Har minskade symtom inom 3 mån',
    summaryBasedOn: 'Baserat på screeningar och uppföljningar.',
    testimonialsTitle: 'I egna ord',
    testimonialsIntro: 'Så säger era medarbetare.',
    testimonialsFootnote: 'Citaten är anonymiserade fritextsvar från uppföljningen.',
    summaryPct: '{{pct}}%',
    notEnoughScreeningData: 'Fler screeningar behövs för att visa den här statistiken.',
    notEnoughFollowUpData: 'Fler uppföljningar behövs för att visa den här statistiken.',
    trainingSection: 'Utbildning',
    womensHealthTrainingChart: 'Deltagande i utbildning om kvinnohälsa',
    moreComingSoon: 'Mer statistik kommer visas här framöver.',
    healthProgramTitle: 'Hälsoprogrammet',
    healthProgramIntro:
      'Hälsoprogrammet hjälper medarbetaren att gå från insikt till handling genom personliga rekommendationer för egenvård och vägledning till vård vid behov.',
    participantsTitle: 'Deltagare i hälsoprogrammet',
    participantsDenominator: 'i hälsoprogrammet sedan start',
    followUpOutcomesTitle: 'Vad hälsoplanen leder till',
    followUpOutcomesIntro:
      'Många omsätter hälsoplanen i handling. {{selfCarePct}}% uppger att de följer råd om egenvård, och {{soughtCarePct}}% bland de som behöver vård rapporterar att de tagit nästa steg och sökt hjälp.',
    healthPlanRelevanceTitle: 'Upplevde att hälsoplanen var relevant',
    relevanceCompletely: 'Instämmer helt',
    relevancePartially: 'Instämmer delvis',
    relevanceNotAtAll: 'Instämmer inte alls',
    followedSelfCareTitle: 'Följer råd om egenvård',
    soughtCareTitle: 'Har sökt vård vid behov',
    outcomeImproved: 'Förbättrats',
    outcomeUnchanged: 'Oförändrat',
    outcomeWorsened: 'Försämrats',
    outcomeUnit: '%',
    outcomesEyebrow: 'Effekten av tjänsten',
    outcomesIntro: 'Så förändras besvär och arbetsförmåga efter att en medarbetare fått sin personliga hälsoplan.',
    symptomChangeTitle: 'Hur besvären förändras',
    symptomChangeCaption:
      'Många besvär minskar från utgångsläget. Självskattad förändring av vanliga symtom vid uppföljning, jämfört med screening.',
    symptomMenstrualPain: 'Mensvärk',
    symptomHotFlashes: 'Värmevallningar',
    symptomBrainFog: 'Koncentrationssvårigheter',
    symptomSleepDifficulties: 'Sömnbesvär',
    symptomIrritability: 'Irritabilitet',
    productivityChangeTitle: 'Hur produktiviteten förändras',
    productivityChangeCaption:
      'Självskattad förändring i produktivitet vid uppföljning, bland de som initialt hade måttlig till hög produktivitetspåverkan.',
    productivityChangeCaptionWithData:
      '<bold>{{improvedPct}}% upplever förbättrad produktivitet</bold> bland dem vars besvär från början hade en måttlig till stor påverkan på arbetet. Ytterligare {{unchangedPct}}% upplever att produktiviteten är oförändrad. (Självskattning vid screening och uppföljningar).',
    competenceTitle: 'Utbildning',
    competenceIntro:
      'Kunskap hos både medarbetare och chefer är en viktig del i att skapa en mer hållbar arbetsmiljö kring kvinnohälsa. Här visas hur många som har påbörjat och genomfört utbildningarna.',
    completionCompleted: 'Genomförd',
    completionInProgress: 'Pågående',
    completionNotStarted: 'Ej påbörjad',
    completionUnit: 'personer',
    eligibleCoworkers: 'Alla medarbetare, {{count}} totalt',
    eligibleManagers: 'Medarbetare med personalansvar, {{count}} totalt',
    womensHealthTrainingName: 'Grundutbildning i kvinnohälsa',
    managerTrainingName: 'Ledarutbildning',
    needsTitle: 'Behovet i er organisation',
    needsIntro:
      'Screeningen ger en bild av vilka besvär kopplade till hormonell och gynekologisk hälsa som finns bland de medarbetare som deltagit, hur svåra besvären är och hur de påverkar vardag och arbete.',
    needsIntroDetail:
      '<bold>{{severePct}}% av screenade medarbetare har minst ett svårt besvär och {{carePct}}% rekommenderas att söka vård.</bold> Det visar att programmet når personer med konkreta hälsobehov och kan hjälpa dem vidare till rätt stöd.',
    severityByConditionTitle: 'Vanligaste besvären',
    severityByConditionCaptionEmpty: 'Antal kvinnor per besvär. En kvinna kan ha flera besvär.',
    severityByConditionCaption: 'Antal kvinnor med besvär. En kvinna kan ha flera besvär.',
    severityByConditionUnit: 'kvinnor',
    conditionPmsPmds: 'PMS & PMDS',
    conditionMenopause: 'Perimenopaus & klimakteriet',
    conditionMenstrualPain: 'Mensvärk',
    conditionIncontinence: 'Inkontinens',
    conditionHeavyBleeding: 'Rikliga blödningar',
    impactLow: '0–3 låg',
    impactModerate: '4–6 måttlig',
    impactHigh: '7–10 hög',
    workImpactProductivityTitle: 'Påverkan på produktiviteten i arbetet',
    workImpactProductivityCaption:
      'Så svarar kvinnorna om hur mycket besvären påverkar produktiviteten, per svårighetsgrad',
    workImpactTierMild: 'Lindriga besvär',
    workImpactTierModerate: 'Måttliga besvär',
    workImpactTierSevere: 'Svåra besvär',
    workImpactTierMildModerate: 'Lindriga och måttliga besvär',
    workImpactTierAll: 'Alla besvär',
    percentValue: '{{value}}%',
    ageDistributionTitle: 'Åldersfördelning',
    ageDistributionCaption: 'Ålder vid screeningtillfället.',
    careLevelTitle: 'Rekommenderades att söka vård',
    severityTitle: 'Har minst ett svårt besvär',
    lifePhasesTitle: 'Ett stöd som följer kvinnan <highlight>genom livet</highlight>.',
    lifePhasesDescription:
      'Från mens och PMS, via graviditet och tiden efter förlossning, till klimakteriet. EsterCare möter kvinnors behov med riktade insatser och program i varje fas.',
    lifePhasesExample: 'Exempel: Anna får tillgång till plattformen vid 26 års ålder och möter rätt stöd i varje fas.',
    lifePhasesAge1: '26 år',
    lifePhasesLabel1: 'Mens & PMS',
    lifePhasesAge2: '31 år',
    lifePhasesLabel2: 'Fertilitet & graviditet',
    lifePhasesAge3: '33 år',
    lifePhasesLabel3: 'Efter graviditet',
    lifePhasesAge4: '45 år',
    lifePhasesLabel4: 'Förklimakteriet',
    lifePhasesAge5: '50 år',
    lifePhasesLabel5: 'Klimakteriet',
    lifePhasesConditionsLabel: 'Oavsett livsfas upptäcker vi även sjukdomar/tillstånd som:',
    lifePhasesCondition1: 'Endometrios',
    lifePhasesCondition2: 'PMOS',
    lifePhasesCondition3: 'Sköldkörtelproblematik',
    lifePhasesCondition4: 'Svampinfektion',
    lifePhasesCondition5: 'Vulvodyni',
    exportReport: 'Exportera rapport',
    exportWarningTitle: 'Innan du exporterar',
    exportUnsupportedText: 'Export av rapporten stöds i Chrome och Edge. I andra webbläsare kan layouten bli felaktig.',
    exportInsufficientDataText:
      'Ni har ännu inte tillräckligt med data för alla delar av rapporten. Grafer som saknar underlag visas med en förklaring i stället för siffror.',
    exportAnyway: 'Exportera ändå',
    reportGeneratedAt: 'Exporterad {{date}}',
    reportFooter:
      'Rapporten är framtagen av EsterCare Workplace Solutions. All statistik är aggregerad, anonymiserad och visas bara när underlaget är tillräckligt stort.',
  },
  services: {
    activeTitle: 'Aktiverade tjänster',
    title: 'Tjänster',
    description1: 'Här har vi samlat alla tjänster som ingår i vår hälsoportal.',
    description2:
      'Som administratör har du möjlighet att enkelt aktivera de tjänster som du vill ska ingå i ert erbjudande.',
    addMoreTitle: 'Lägg till fler tjänster',
  },
  policy: {
    title: 'Policy för kvinnohälsa',
    description: 'Här erbjuds en mall som kan användas som utgångspunkt för att ta fram en policy för er arbetsplats.',
    downloadLabel: 'Ladda ned',
    backgroundTitle: 'Bakgrund & syfte',
    actionsTitle: 'Åtgärder',
    principlesTitle: 'Grundläggande principer',
    responsibilityTitle: 'Ansvar',
    educationSubtitle: 'Utbildning & medvetenhet',
    preventiveSubtitle: 'Preventiva & hälsofrämjande insatser',
    workEnvironmentSubtitle: 'Arbetsmiljö',
    backgroundParagraph1:
      'Kvinnor möter olika hälsomässiga utmaningar under olika faser av sina liv från reproduktiv hälsa till klimakteriet. Besvär och sjukdomar kopplade till deras gynekologiska och hormonella hälsa existerar utan motsvarande hos män. Kvinnohälsa måste tas på allvar och uppmärksammas på arbetsplatsen för att säkerställa att kvinnor ges samma förutsättningar att prestera som män.',
    backgroundParagraph2:
      'Undersökningar visar att kvinnors hälsa ofta förbises eller marginaliseras både inom hälso- och sjukvårdssystemet samt på arbetsplatser. Det är därför viktigt att arbetsgivare aktivt tar ansvar för att adressera dessa behov och skapa en miljö där kvinnor känner sig hörda och stöttade i sin hälsa.',
    backgroundParagraph3:
      'Genom att erkänna att könsspecifika hälsoproblem existerar tar vårt företag ett steg mot att främja en mer jämställd och hälsosam arbetsplats. Att införliva en policy för kvinnohälsa visar vårt engagemang.',
    backgroundParagraph4:
      'Med implementeringen av denna policy kommer vi att säkerställa att våra anställda får tillgång till relevant information, resurser och stöd kopplat till kvinnohälsa.',
    backgroundParagraph5:
      'Genom att aktivt stödja kvinnors hälsa investerar vi inte bara i våra anställdas välbefinnande, utan även i vår organisations långsiktiga framgång och hållbarhet.',
    principlesParagraph1:
      'Policyn för kvinnohälsa syftar till att främja lika förutsättningar för alla anställda, oavsett kön, att prestera och känna välbefinnande på arbetsplatsen. Policyn är utformad för att skapa en inkluderande arbetsmiljö där varje individ behandlas med respekt och ges samma möjligheter att utvecklas och bidra till företagets framgång.',
    principlesParagraph2:
      'Alla anställda ska ha rätt till en hälsosam och trygg arbetsmiljö. Vi erkänner att kvinnor kan ha specifika hälsobehov och utmaningar som påverkar deras välbefinnande och prestation på arbetsplatsen.',
    principlesParagraph3:
      'Vi förbinder oss att respektera och värna om alla anställdas integritet och värdighet. Ingen ska bli diskriminerad eller behandlad orättvist på grund av kön, hälsotillstånd eller andra personliga omständigheter.',
    principlesParagraph4:
      'Vi arbetar för en öppen och transparent kommunikation kring hälsofrågor. Alla anställda ska känna sig bekväma att diskutera hälsorelaterade bekymmer och få stöd när de behöver det.',
    principlesParagraph5:
      'Vi strävar efter att erbjuda flexibilitet och anpassningar för att möta individuella hälsobehov och främja en hälsosam balans mellan arbete och privatliv.',
    principlesParagraph6:
      'Vi förbinder oss att kontinuerligt utbilda och informera alla anställda om kvinnohälsa och jämställdhet för att skapa en mer medveten och stödjande arbetsmiljö.',
    responsibilityParagraph1:
      'Det är viktigt att tydligt definiera och fördela ansvar för implementeringen och efterlevnaden av policyn för kvinnohälsa på vår arbetsplats. Nedan beskrivs vilka som är ansvariga för olika delar av policyn:',
    responsibilityManagement: 'Ledningsgruppen:',
    responsibilityManagementText:
      'Ansvarar för att fastställa policyns övergripande mål och riktlinjer samt för att tillhandahålla nödvändiga resurser för dess genomförande.',
    responsibilityHR: 'HR-avdelningen:',
    responsibilityHRText:
      'Har huvudansvaret för att administrera och övervaka implementeringen av policyn. Detta inkluderar att se till att policyn kommuniceras till alla anställda, att genomföra utbildning och utvärderingar samt att hantera eventuella klagomål eller överträdelser av policyn.',
    responsibilityManagers: 'Chefer och ledare:',
    responsibilityManagersText:
      'Förväntas stödja och främja policyn bland sina teammedlemmar genom att agera som föredömen och förespråkare för jämställdhet och kvinnors hälsa. De är även ansvariga för att uppmuntra öppen kommunikation och rapportering av eventuella problem relaterade till policyn.',
    responsibilityEmployees: 'Alla anställda:',
    responsibilityEmployeesText:
      'Förväntas följa policyn och aktivt bidra till att skapa en inkluderande och hälsosam arbetsmiljö genom att behandla varandra med respekt och agera i enlighet med policyns principer och riktlinjer.',
    principlesParagraph7:
      'Denna policy är tillämplig på alla anställda inom bolaget, oberoende av deras roll, geografiska placering eller anställningsstatus.',
    actionsIntro:
      'Åtgärder innefattar initiativ och resurser som syftar till att förebygga hälsoproblem eller minska risken för deras uppkomst bland våra kvinnliga anställda. Detta inkluderar att erbjuda utbildning för att öka kunskapen och bryta tabun samt tillhandahålla hälsofrämjande stöd när det behövs.',
    educationPoint1:
      'Vi erbjuder alla anställda möjligheten att ta del av en digital utbildning om kvinnohälsa för att säkerställa att alla får grundläggande kunskap om kvinnokroppen samt olika utmaningar kopplat till den.',
    educationPoint2:
      'Vi säkerställer även tillgång till vetenskaplig information om kvinnokroppen genom artiklar och poddavsnitt.',
    educationPoint3:
      'Vi erbjuder alla chefer en digital utbildning om kvinnohälsa med fokus på hur olika problem kan påverka individen och dess möjlighet att utföra arbetsuppgifter på ett fullgott sätt.',
    educationPoint4:
      'Vi arbetar aktivt för att minska stigma och tabu kopplat till menstruation, klimakteriet och andra ämnen kopplat till kvinnohälsa genom öppen kommunikation och utbildningsinitiativ.',
    educationPoint5:
      'Varje chef ansvarar för att sprida information om och genomförandet kring utbildningar för att säkerställa att vi kontinuerligt förbättrar och främjar detta arbete.',
    preventivePoint1:
      'Vi erbjuder alla kvinnliga anställda ett årligt screeningprogram för kvinnohälsa för att identifiera och fånga upp symptom samt besvär som kan behandlas men som obehandlat orsakar onödigt lidande och sänkt livskvalitet.',
    preventivePoint2:
      'Vi erbjuder alla kvinnliga anställda möjligheten att få en personaliserad hälsoplan som är anpassad efter deras unika förutsättningar, utmaningar och behov.',
    preventivePoint3: 'Vi erbjuder alla kvinnliga anställda hälsosamtal med en barnmorska.',
    workEnvironmentPoint1:
      'Vi erbjuder gratis mensskydd på samtliga toaletter på arbetsplatsen eller att ta med om arbetet utförs utanför kontoret.',
    workEnvironmentPoint2:
      'Vi säkerställer att våra kvinnliga anställda har tillgång till toaletter med rinnande vatten under arbetsdagen.',
    workEnvironmentPoint3:
      'Vi erbjuder flexibla arbetstidsarrangemang, möjlighet till hemarbete och kortare pauser för att hantera besvär kopplat till kvinnohälsa. Samt att hälsosamtal, vårdbesök eller besök inom ramen för nationella screeningprogram kopplade till kvinnohälsa får utföras på arbetstid.',
    principleRespect: 'Respekt och Värdighet:',
    principleRespectText:
      'Vi strävar efter att behandla alla medarbetare med respekt och värdighet oavsett ålder eller kön. Vi främjar en inkluderande arbetsmiljö där jämställdhet hyllas, hälsotillstånd inte förminskas eller förlöjligas och där alla har rätt till lika möjligheter.',
    principleNonDiscrimination: 'Förebyggande av Diskriminering och Förlöjligande:',
    principleNonDiscriminationText:
      'Vi förväntar oss att alla anställda visar respekt och tolerans gentemot varandra och agerar kraftfullt om de observerar diskriminerande eller förlöjligande beteende. Vi tar sådana situationer på allvar och utreder alla anklagelser för att säkerställa att lämpliga åtgärder vidtas.',
    principleInclusive: 'Inkluderande arbetsplats:',
    principleInclusiveText:
      'Vi strävar efter att vara en inkluderande arbetsplats där alla anställda behandlas lika och ges samma förutsättningar. Vi arbetar aktivt med att främja en kultur av öppenhet och förståelse där alla anställda känner sig bekväma med att prata om sådant som påverkar arbetsprestationen.',
  },
  service: {
    priceProposalMobile: 'Få ett prisförslag',
    priceProposalDesktop: 'Få ett prisförslag och aktivera tjänsten för era anställda',
    activeStatus: 'AKTIV',
    loadingMessage: 'Vänligen vänta medan vi behandlar din förfrågan.',
    successTitle: 'Vi har mottagit din förfrågan!',
    successDescription:
      'Inom 1-2 arbetsdagar återkommer med ett prisförslag. Därefter hjälper vi er att snabbt och smidigt komma igång med tjänsten i er organisation.',
    errorTitle: 'Något gick fel',
    errorDescription: 'Prova en gång till eller kontakta vår support.',
  },
  certification: {
    pageTitle: 'Certifiering',
    title: 'Equal Health Certification',
    description:
      'Equal Health Certification är en kvalitetsmärkning för arbetsplatser som vill arbeta strukturerat med kvinnohälsa och jämställd hälsa. \nCertifieringen hjälper er att förstå var organisationen står idag, synliggöra det ni redan gör bra och identifiera områden där ni kan utvecklas.\n\nNästa steg är att fylla i certifieringsenkäten. Du svarar på frågor för organisationens räkning och utifrån svaren sammanställs en rapport med era styrkor och förbättringsområden. Ni får också konkreta rekommendationer som hjälper er att prioritera nästa steg och skapa långsiktig förändring.',
    consentText:
      'Genom att fortsätta godkänner du att EsterCare behandlar och lagrar de uppgifter du lämnar i certifieringsenkäten.',
    startButton: 'Påbörja certifieringen',
    continueButton: 'Fortsätt med certifieringen',
    uploadTitle: 'Bifoga er policy för kvinnohälsa',
    uploadDescription:
      'Bifoga er policy som PDF så tar vårt team hänsyn till den i bedömningen. Du kan hoppa över det här steget om du inte har någon policy att bifoga.',
    uploadFileTooLarge: 'Filen är för stor. Varje fil får vara högst {{maxSize}} MB.',
    uploadTooManyFiles: 'Du kan bifoga högst {{maxFiles}} filer.',
    uploadWrongFileType: 'Endast PDF-filer kan bifogas.',
    uploadRejected: 'Filen kunde inte bifogas. Prova en annan fil.',
    removeDocument: 'Ta bort {{fileName}}',
    submitTitle: 'Dags att skicka in',
    submitDescription:
      'Nu är alla frågor besvarade. När bedömningen är klar kan du ta del av er rapport, med styrkor och förbättringsområden samt rekommenderade nästa steg.',
    submitNextSteps: 'Vi hör av oss via mail när den finns tillgänglig i portalen.',
    submitButton: 'Skicka in svaren',
    previousQuestionError: 'Vi kunde inte hämta föregående fråga. Prova en gång till.',
    submittedTitle: 'Tack!',
    submittedDescription: 'Vi hör av oss så snart era resultat är klara.',
    pendingTitle: 'Era svar hanteras',
    pendingDescription: 'Ni får ett mail när rapporten är färdigställd',
    resultsTitle: 'Equal Health Certification',
    resultsDescription:
      'En kvalitetsmärkning för jämnställd hälsa på arbetsplatsen - grundad på globala standarder. Den vägleder arbetsgivare i att skapa tryggare, friskare och mer inkluderande arbetsplatser för kvinnor.',
    notAchievedCertification: 'Er arbetsplats har ännu inte uppnått Equal Health Certification',
    achievedCertification: 'Er arbetsplats har uppnått Equal Health {{level}}',
    downloadLogo: 'Ladda ner logotyp',
    levelBadge: 'LEVEL {{level}}',
    foundationTitle: 'Equal Health Foundation',
    foundationDescription:
      'Er organisation har tagit viktiga första steg mot att integrera kvinnohälsa i arbetsplatsens riktlinjer och arbetssätt. Denna nivå uppmärksammar medvetenhet, tidiga initiativ och en tydlig vilja att skapa en mer inkluderande och stödjande arbetsmiljö för alla medarbetare.',
    advancedTitle: 'Equal Health Advanced',
    advancedDescription:
      'Er organisation har infört strukturerade rutiner och ett aktivt arbetssätt kring kvinnohälsa som genomsyrar flera delar av verksamheten. Denna nivå visar på ett tydligt engagemang och kontinuerligt arbete för en mer jämställd och hälsofrämjande arbetsplats.',
    excellenceTitle: 'Equal Health Excellence',
    excellenceDescription:
      'Er organisation är ledande inom kvinnohälsa på arbetsplatsen och har gjort det till en naturlig del av kulturen och strategin. Denna nivå representerar det högsta engagemanget för en trygg, inkluderande och hälsofrämjande arbetsmiljö för alla medarbetare.',
    reportTitle: 'Rapport',
    reportDescription:
      'Här hittar ni er certifieringsrapport, som visar resultatet av EsterCares genomlysning av er organisations arbete med kvinnohälsa på arbetsplatsen. Rapporten redovisar er certifieringsnivå, en sammanfattning av era styrkor samt konkreta förbättringsområden inom de fyra bedömda områdena: policy och styrning, arbetsmiljö och anpassningar, kompetens och kultur samt hälsoinsatser och flexibilitet.',
    reportDownloadCta:
      'Ladda ner rapporten för att ta del av den fullständiga bedömningen och rekommendationerna för nästa steg.',
    downloadReport: 'Ladda ner rapporten',
    nextStepsTitle: 'Rekommenderade nästa steg',
  },
  support: {
    questionsTitle: 'Har du några frågor eller funderingar?',
    contactMessage: 'Maila till',
    contactEmail: 'hello@estercare.com',
    contactContinue: 'så hjälper vi dig!',
  },
} as const
